export const ZOMBIES = {
    NORMAL: {
        key: 'normal_zombie',
        name: '普通僵尸',
        cost: 50,
        health: 200,
        damage: 20,
        speed: 20,
        attackSpeed: 2000,
    },
    CONE: {
        key: 'cone_zombie',
        name: '路障僵尸',
        cost: 75,
        health: 370,
        damage: 20,
        speed: 20,
        attackSpeed: 2000,
    },
    BUCKET: {
        key: 'bucket_zombie',
        name: '铁桶僵尸',
        cost: 125,
        health: 650,
        damage: 20,
        speed: 20,
        attackSpeed: 2000,
    },
};
